// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { CreditCard } from './credit-card';
import { Dealer } from './dealer';
import { InvoicePaymentMethod } from './invoice-payment-method';
import { PaymentLine } from './payment-line';

/// <code-import> Place custom imports between <code-import> tags
import _ from 'lodash';
import moment from 'moment';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Payment extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  static getNextLineNumber(lines: any[]) {
        if (lines.length === 0) return 1;

        let lineNumber: any;
        lineNumber = _.maxBy(lines, 'lineNumber').lineNumber + 1;
        return lineNumber;
    }

    get exported() {
        return !!this.readyToExport && this.quickBooksId !== null && !!this.quickBooksLastExport;
    }

    get salesOrderList() {
        const salesOrderList = [];
        if (this.paymentLines && this.paymentLines.length > 0) {
            this.paymentLines.forEach((line) => {
                if (line.orderLineDetail && !_.includes(salesOrderList, line.orderLineDetail.orderLine.order.invoiceNumber)) {
                    salesOrderList.push(line.orderLineDetail.orderLine.order.invoiceNumber);
                }
            });
        }
        return salesOrderList.join('; ');
    }

    get invoiceList() {
        const invoiceList = [];
        if (this.paymentLines && this.paymentLines.length > 0) {
            this.paymentLines.forEach((line) => {
                if (line.invoice && !_.includes(invoiceList, line.invoice.invoiceNumber)) {
                    invoiceList.push(line.invoice.invoiceNumber);
                }
            });
        }
        return invoiceList;
    }
    get invoiceListString() {
        return this.invoiceList.join('; ');
    }

    get paymentAmount() {
        let lineSum = _.sumBy(this.paymentLines.filter(line => !line.deleted), 'amount');
        let feeSum = this.northpointFee ? this.northpointFee : 0;
        return lineSum + feeSum;
    }
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  created!: Date;
  createdBy?: string;
  creditCardId?: number;
  creditCardLastDigits?: string;
  dealerId!: number;
  deleted?: Date;
  deletedBy?: string;
  northpointFee!: number;
  notes?: string;
  paymentDate!: Date;
  paymentMethodId!: number;
  quickBooksId?: string;
  quickBooksLastExport?: Date;
  readyToExport?: Date;
  referenceNumber?: string;
  total!: number;
  creditCard!: CreditCard;
  dealer!: Dealer;
  paymentLines!: PaymentLine[];
  paymentMethod!: InvoicePaymentMethod;
}

